import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const adsRepublishService = {
  async getPrint(userId: number, categoryId: number, uniqueId: string): Promise<any[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_PRINT_REPUBLISH
          .replace(':userId', String(userId))
          .replace(':categoryId', String(categoryId))
          .replace(':uniqueId', uniqueId),
          config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      console.log(`Error service adsRepubish getPrint: ${e}`);
      throw new Error(e);
    }
  },
  async getWeb(webId: number): Promise<any[]> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_WEB_REPUBLISH
          .replace(':webId', String(webId))
      );
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      console.log(`Error service adsRepubish getWeb: ${e}`);
      throw new Error(e);
    }
  }
}